//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {};
    },
    mounted() {},
    methods: {
        backToTop() {
            $('#middle').animate(
                {
                    scrollTop: 0
                },
                500
            );
        }
    }
};



// WEBPACK FOOTER //
// ./src/pcComponents/common/backToTop.vue